import React, {useEffect, useState} from "react";
import Api from "../../../services/api.js";
import {toast} from "react-toastify";
import {Modal,Button} from 'react-bootstrap';
import LoadingComponent from "../../../components/loading";

function DataConnectors() {
    const [searchTerm, setSearchTerm] = useState(false);  // Lưu nội dung input
    const [searchValue, setSearchValue] = useState("");
    const [showModal, setShowModal] = useState(false);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refresh, setRefresh] = useState(false);



    const fetchData = (search) => {
        setLoading(true);
        Api.get(`/api/data_connector?search=${search}`)
            .then(result => {
                if (result.data.code == 0) {
                    setData(result.data.data);
                } else {
                    toast.error("Lỗi lấy dữ liệu !!");
                }
                setLoading(false)
            });
    };

    useEffect(() => {
        fetchData("");
    }, []);

    useEffect(() => {
        fetchData(searchValue);
    }, [searchTerm]);


    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            setSearchTerm(!searchTerm);
        }
    };


    return (
        <>
            <section className="main__content">
                <div className="container-fluid">
                <div className="detail-body">
                    <div className="overview_content pd-20">
                        <div className="mb-6">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="title-head-box">
                                        <p className="title-block">Alerts</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <nav>
                                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                            <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab"
                                                    data-bs-target="#nav-home" type="button" role="tab"
                                                    aria-controls="nav-home" aria-selected="true">Alerts
                                            </button>
                                            <button className="nav-link" id="nav-profile-tab" data-bs-toggle="tab"
                                                    data-bs-target="#nav-profile" type="button" role="tab"
                                                    aria-controls="nav-profile" aria-selected="false">Settings
                                            </button>
                                        </div>
                                    </nav>
                                    <div className="tab-content" id="nav-tabContent">
                                        <div className="tab-pane fade show active" id="nav-home" role="tabpanel"
                                             aria-labelledby="nav-home-tab">...
                                        </div>
                                        <div className="tab-pane fade" id="nav-profile" role="tabpanel"
                                             aria-labelledby="nav-profile-tab">
                                            <div className="box box--chart" style={{ marginTop: "25px" }}>
                                                <div className="box__content custom-table">
                                                    <div className="row d-flex align-items-center justify-content-between">
                                                        <div className="col-md-3 mt-2">
                                                            <div className="form-group m-0">
                                                                <div className="form-line">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control input-form-control"
                                                                        name="search"
                                                                        value={searchValue}
                                                                        onChange={(e) => setSearchValue(e.target.value)}
                                                                        onKeyDown={handleKeyDown}
                                                                        placeholder="Search"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2 mt-2">
                                                            <button style={{ float: "right"}} className="btn btn-primary" onClick={() => setShowModal(true)}>
                                                                + New Rule
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <LoadingComponent loading={loading} />
                                                    <div className="table-responsive">
                                                        <table className="table m-0 table--text-bold">
                                                            <thead>
                                                            <tr className="border-bt">
                                                                <th>Name</th>
                                                                <th>Type</th>
                                                                <th>Status</th>
                                                                <th>Last Update</th>
                                                                <th>Last Imported</th>
                                                                <th>Action</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {data.length > 0 ? (
                                                                data.map((item) => (
                                                                    <tr key={item.id} className="hover:bg-gray-100">
                                                                        <td>
                                                                            {item.name}
                                                                        </td>
                                                                        <td>{item.type}</td>
                                                                        <td>{item.status}</td>
                                                                        <td>{item.last_update}</td>
                                                                        <td>{item.last_imported_date}</td>
                                                                        <td>
                                                                            <a href="#" style={{ padding: "0 6px" }}>
                                                                                <i className="fa fa-edit"></i>
                                                                            </a>
                                                                            <a href="#" style={{ padding: "0 6px" }}>
                                                                                <i className="fa fa-sync"></i>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="6" className="border border-gray-300 px-4 py-2 text-center">
                                                                        No data available
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="modal-lg">
                    <Modal.Header>
                        <h5 className="modal-title">New Rule</h5>
                        <button type="button" className="close" onClick={() => setShowModal(false)}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="ruleName">Name</label>
                                        <input type="text" className="form-control" id="ruleName"
                                               placeholder="Enter rule name" />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="breakdown">Breakdown</label>
                                        <select className="form-control" id="breakdown" disabled>
                                            <option>Select dimensions</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Applicable Apps</label>
                                <select className="form-control">
                                    <option>All Apps</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Conditions</label>
                                <div className="row">
                                    <div className="col-md-4 d-flex align-items-center justify-content-between">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="dateRange"
                                                   id="dateRange1" />
                                            <label className="form-check-label" htmlFor="dateRange1">Date
                                                Range</label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="dateRange"
                                                   id="dateRange2" />
                                            <label className="form-check-label"
                                                   htmlFor="dateRange2">Intraday</label>
                                        </div>
                                    </div>
                                </div>


                            </div>

                            <div className="form-group">
                                <label>Date Range</label>
                                <div className="row">
                                    <div className="input-group col-md-4 mt-2">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">Last</span>
                                        </div>
                                        <input type="number" className="form-control" value="7" />
                                        <div className="input-group-append">
                                            <span className="input-group-text">days</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="row g-2">
                                <div className="col-md-4">
                                    <select className="form-select form-control">
                                        <option selected>Country</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <select className="form-select form-control">
                                        <option selected>equals</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" value="United States" />
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <button className="btn btn-outline-secondary">➖</button>
                                    <button className="btn btn-outline-secondary ms-2">➕</button>
                                </div>
                            </div>

                            <div className="row g-2 mt-2">
                                <div className="col-md-4">
                                    <select className="form-select form-control">
                                        <option selected>Select a metric</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <select className="form-select form-control">
                                        <option selected>between</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <input type="text" className="form-control" placeholder="Min" />
                                </div>
                                <div className="col-md-2">
                                    <input type="text" className="form-control" placeholder="Max" />
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <button className="btn btn-outline-secondary">➖</button>
                                    <button className="btn btn-outline-secondary ms-2">➕</button>
                                </div>
                            </div>

                            <div className="row g-2 mt-2">
                                <div className="col-md-1 d-flex align-items-center">
                                    <input type="checkbox" disabled />
                                </div>
                                <div className="col-md-3">
                                    <input type="text" className="form-control" placeholder="Metric"
                                           disabled />
                                </div>
                                <div className="col-md-3">
                                    <input type="text" className="form-control" placeholder="Increased by"
                                           disabled />
                                </div>
                                <div className="col-md-3">
                                    <div className="input-group">
                                        <input type="text" className="form-control" placeholder="Threshold"
                                               disabled />
                                        <div className="input-group-append">
                                            <span className="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <span>compared to the last period</span>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-3 d-flex align-items-center justify-content-between">
                                    <span className="me-2">Notification</span>
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                            Close
                        </button>
                        <button type="button" className="btn btn-primary">Save changes</button>
                    </Modal.Footer>
                </Modal>
            </div>
            </section>
        </>
    );
}

export default DataConnectors;
